import { render, staticRenderFns } from "./AdminBlogForm.vue?vue&type=template&id=20a90ee0&"
import script from "./AdminBlogForm.vue?vue&type=script&lang=js&"
export * from "./AdminBlogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports